import _noop from 'lodash/noop';

const searchContextPropType=_noop;var searchContextPropType$1 = searchContextPropType;

const searchContextImmutablePropType=_noop;var searchContextImmutablePropType$1 = searchContextImmutablePropType;

export { searchContextImmutablePropType$1 as searchContextImmutablePropType, searchContextPropType$1 as searchContextPropType };
